/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-10 10:13:48
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-16 14:45:08
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/utils/httph5.js
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
 */
import axios from "axios";

import i18n from "@/lang/index";
import Vue from "vue";
import router from "@/router/index";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 60000, // 请求超时时间
  method: "post",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// request 拦截
service.interceptors.request.use(
  (config) => {
    if (config.method === "post") {
      config.data = config.data;
    }

    var token = localStorage.getItem("token");
    var headerClientInfo = {
      language: "CN",
      eventKey: localStorage.getItem("eventKey") ||  "WeMeet",
      appKey: localStorage.getItem("appKey") || "WX_MINI_WEMEET",
      from: "H5",
    };
    config.headers["x-call-client-info"] = JSON.stringify(headerClientInfo);
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return error;
  }
);

// response 拦截
service.interceptors.response.use(
  (response) => {
    if (response.data.code != 200) {
      if (response.data.code == 401) {
        Vue.prototype.$toast(i18n.t("lang.t310"));
        localStorage.clear();
        setTimeout(() => {
          router.push("/mini-h5/index/userRegister");
        }, 1500);
      }
      
      return Promise.reject(response.data);
    } else {
      return response.data;
    }
  },
  (error) => {
    return error.data;
  }
);

export default service;
